import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRightSmall = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M13.7188 9.3125L8.71875 4.3125C8.34375 3.90625 7.6875 3.90625 7.3125 4.3125C6.90625 4.6875 6.90625 5.34375 7.3125 5.71875L11.5938 10L7.3125 14.3125C6.90625 14.6875 6.90625 15.3438 7.3125 15.7188C7.6875 16.125 8.34375 16.125 8.71875 15.7188L13.7188 10.7188C14.125 10.3438 14.125 9.6875 13.7188 9.3125Z"
	})
});
const ForwardRef = forwardRef(SvgArrowRightSmall);
export default ForwardRef;
